import useJsonApi from "lib/useJsonApi.js";

function useSessionPhotosToPrint(sessionUuid) {
  return useJsonApi({
    url: `/api/session/${sessionUuid}/photos-to-print`,
  });
}

export default useSessionPhotosToPrint;
